import React from 'react'
import { useStaticProps } from '../../../../../../../contexts/staticProps.context'

const iconUrlMap = dMethod => {
  if (dMethod === 'SameDay') return 'sameday'
  if (dMethod === 'NextDay') return 'nextday'
  if (dMethod === 'NextBusinessDay') return 'nextbusinessday'
  if (dMethod === '2 Day') return '2day'
  if (dMethod === 'Overnight') return 'overnight'
  if (dMethod === 'Economy') return 'economy'
  return 'standard'
}

export const GetShippingIcon = ({ dMethod }) => {
  const staticProps = useStaticProps()
  const { lastmileIcons } = staticProps || {}
  const iconUrl = lastmileIcons?.[iconUrlMap(dMethod)]

  if (!iconUrl) return null

  return <img src={iconUrl} alt={`${dMethod} delivery`} />
}
